import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=18c769b8&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c769b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18c769b8')) {
      api.createRecord('18c769b8', component.options)
    } else {
      api.reload('18c769b8', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=18c769b8&scoped=true", function () {
      api.rerender('18c769b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/customFormConfig/edit.vue"
export default component.exports